const TIMELINE_WORDINGS = {
    'annotation.created': (subs) => {
        return window.i18n.__('%(staff)s a créé le commentaire', subs);
    },
    'annotation.deleted': (subs) => {
        return window.i18n.__('%(staff)s a supprimé le commentaire', subs);
    },
    'annotation.replied': (subs) => {
        return window.i18n.__('%(staff)s a répondu au commentaire', subs);
    },
    'annotation.updated': (subs) => {
        return window.i18n.__('%(staff)s a modifié le commentaire', subs);
    },

    'email.draft.created': (subs) => {
        return window.i18n.__('%(staff)s a créé le brouillon', subs);
    },
    'email.draft.deleted': (subs) => {
        return window.i18n.__('%(staff)s a supprimé le brouillon', subs);
    },
    'email.draft.updated': (subs) => {
        return window.i18n.__('%(staff)s a modifié le brouillon', subs);
    },
    'email.scheduled.deleted': (subs) => {
        return window.i18n.__("%(staff)s a supprimé la programmation de l'email", subs);
    },
    'email.scheduled.created': (subs) => {
        return window.i18n.__("%(staff)s a programmé l'envoi de l'email", subs);
    },
    'email.scheduled.sent': () => {
        return window.i18n.__("L'email programmé a été envoyé");
    },
    'email.unlinked': (subs) => {
        return window.i18n.__("%(staff)s a délié l'email", subs);
    },
    'email.link.unlinked': (subs) => {
        return window.i18n.__("%(staff)s a délié l'email", subs);
    },
    'email.linked': (subs) => {
        return window.i18n.__("%(staff)s a lié l'email", subs);
    },
    'email.link.linked': (subs) => {
        return window.i18n.__("%(staff)s a lié l'email", subs);
    },
    'email.link.sent': (subs) => {
        return window.i18n.__("%(staff)s a envoyé l'email", subs);
    },
    'email.sent': (subs) => {
        return window.i18n.__("%(staff)s a envoyé l'email", subs);
    },
    'email.failed': (subs) => {
        return window.i18n.__("%(staff)s n'a pas reçu l'email", subs);
    },
    'email.received': (subs) => {
        return window.i18n.__('%(staff)s a reçu un email', subs);
    },
    'email.thread.replied': (subs) => {
        return window.i18n.__('%(staff)s a reçu une réponse à un email', subs);
    },
    'email.link.replied': (subs) => {
        return window.i18n.__('%(staff)s a reçu une réponse à un email', subs);
    },
    'email.opened': () => {
        return window.i18n.__("L'email a été ouvert");
    },
    'email.link.clicked': () => {
        return window.i18n.__('Le lien a été cliqué');
    },
    'email.delivered': () => {
        return window.i18n.__("L'email a été délivré");
    },
    'email.dropped': () => {
        return window.i18n.__("L'email a été abandonné");
    },
    'email.bounced': () => {
        return window.i18n.__("L'email a été refusé");
    },
    'email.opportunity.marketingautomation.sent': () => {
        return window.i18n.__("L'email a été envoyé");
    },
    'emailengine.sent': () => window.i18n.__("L'email a été envoyé"),
    'emailengine.received': () => window.i18n.__("L'email a été reçu"),
    'emailengine.opened': () => window.i18n.__("L'email a été ouvert"),
    'emailengine.link.clicked': () => window.i18n.__('Le lien a été cliqué'),
    'emailengine.deleted': () => window.i18n.__("L'email a été supprimé"),
    'emailengine.draft.created': () => window.i18n.__("L'email a été enregistré en brouillon"),
    'emailengine.sending.failed': () => window.i18n.__("L'envoi de l'email a échoué"),
    'emailengine.notify.sending.failed': () => window.i18n.__("L'envoi de l'email a échoué"),
    'emailengine.scheduled': () => window.i18n.__("L'email a été programmé"),
    'event.created': (subs) => {
        return window.i18n.__("%(staff)s a créé l'évènement", subs);
    },
    'event.updated': (subs) => {
        return window.i18n.__("%(staff)s a modifié l'évènement", subs);
    },
    'event.deleted': (subs) => {
        return window.i18n.__("%(staff)s a supprimé l'évènement", subs);
    },
    'phonecall.created': (subs) => {
        return window.i18n.__("%(staff)s a créé l'appel", subs);
    },
    'phonecall.updated': (subs) => {
        return window.i18n.__("%(staff)s a modifié l'appel", subs);
    },
    'phonecall.deleted': (subs) => {
        return window.i18n.__("%(staff)s a supprimé l'appel", subs);
    },

    'opportunity.created': (subs) => {
        return subs.from
            ? window.i18n.__("%(staff)s a créé l'opportunité depuis %(from)s", subs)
            : window.i18n.__("%(staff)s a créé l'opportunité", subs);
    },
    'opportunity.updated': (subs) => {
        return window.i18n.__("%(staff)s a modifié l'opportunité", subs);
    },
    'opportunity.deleted': (subs) => {
        return window.i18n.__("%(staff)s a supprimé l'opportunité", subs);
    },
    'opportunity.staff.assigned': (subs) => {
        return window.i18n.__(
            '%(staff)s a associé %(newStaffs)s en tant que collaborateur de l’opportunité',
            subs,
        );
    },
    'opportunity.doc.linked': (subs) => {
        return window.i18n.__("%(staff)s a lié %(document)s à l'opportunité", subs);
    },
    'opportunity.maindoc.updated': (subs) => {
        return window.i18n.__(
            '%(staff)s a défini %(document)s en tant que document principal pour l‘opportunité',
            subs,
        );
    },
    'opportunity.marketingautomation.sended': (subs) => {
        return window.i18n.__("%(staff)s a envoyé un email automation sur l'opportunité", subs);
    },
    'opportunity.owner.updated': (subs) => {
        return window.i18n.__(
            "%(staff)s a changé le propriétaire de %(oldStaff)s à %(newStaff)s pour l'opportunité",
            subs,
        );
    },
    'opportunity.status.updated': (subs) => {
        return window.i18n.__(
            "%(staff)s a modifié le statut de %(oldStatus)s à %(newStatus)s pour l'opportunité",
            subs,
        );
    },
    'opportunity.step.updated': (subs) => {
        return window.i18n.__(
            "%(staff)s a modifié l'étape de %(oldStep)s à %(newStep)s pour l'opportunité",
            subs,
        );
    },
    'opportunity.third.updated': (subs) => {
        return window.i18n.__(
            "%(staff)s a changé la société de %(oldThird)s à %(newThird)s pour l'opportunité",
            subs,
        );
    },

    'opportunity.staff.assigned.linked': (subs) => {
        return window.i18n.__(
            '%(staff)s a associé %(newStaffs)s en tant que collaborateur de l’opportunité %(opportunity)s',
            subs,
        );
    },
    'opportunity.created.linked': (subs) => {
        return window.i18n.__("%(staff)s a créé l'opportunité %(opportunity)s", subs);
    },
    'opportunity.updated.linked': (subs) => {
        return window.i18n.__("%(staff)s a modifié l'opportunité %(opportunity)s", subs);
    },
    'opportunity.doc.linked.linked': (subs) => {
        return window.i18n.__("%(staff)s a lié %(document)s à l'opportunité %(opportunity)s", subs);
    },
    'opportunity.maindoc.updated.linked': (subs) => {
        return window.i18n.__(
            '%(staff)s a défini %(document)s en tant que document principal pour l‘opportunité %(opportunity)s',
            subs,
        );
    },
    'opportunity.marketingautomation.sended.linked': (subs) => {
        return window.i18n.__(
            "%(staff)s a envoyé un email automation sur l'opportunité %(opportunity)s",
            subs,
        );
    },
    'opportunity.owner.updated.linked': (subs) => {
        return window.i18n.__(
            "%(staff)s a changé le propriétaire de %(oldStaff)s à %(newStaff)s pour l'opportunité %(opportunity)s",
            subs,
        );
    },
    'opportunity.status.updated.linked': (subs) => {
        return window.i18n.__(
            "%(staff)s a modifié le statut de %(oldStatus)s à %(newStatus)s pour l'opportunité %(opportunity)s",
            subs,
        );
    },
    'opportunity.step.updated.linked': (subs) => {
        return window.i18n.__(
            "%(staff)s a modifié l'étape de %(oldStep)s à %(newStep)s pour l'opportunité %(opportunity)s",
            subs,
        );
    },
    'opportunity.third.updated.linked': (subs) => {
        return window.i18n.__(
            "%(staff)s a changé la société de %(oldThird)s à %(newThird)s pour l'opportunité %(opportunity)s",
            subs,
        );
    },

    'task.created': (subs) => {
        return window.i18n.__('%(staff)s a créé la tâche', subs);
    },
    'task.updated': (subs) => {
        return window.i18n.__('%(staff)s a modifié la tâche', subs);
    },
    'task.deleted': (subs) => {
        return window.i18n.__('%(staff)s a supprimé la tâche', subs);
    },
    'task.completed': (subs) => {
        return window.i18n.__('%(staff)s a terminé la tâche', subs);
    },
    'task.uncompleted': (subs) => {
        return window.i18n.__('%(staff)s a repris la tâche', subs);
    },
    'task.date.updated': (subs) => {
        return window.i18n.__('%(staff)s a modifié la date de la tâche', subs);
    },
    'task.label.updated': (subs) => {
        return window.i18n.__('%(staff)s a modifié le label de la tâche', subs);
    },
    'task.owner.updated': (subs) => {
        return window.i18n.__('%(staff)s a modifié le propriétaire de la tâche', subs);
    },
    'task.staff.updated': (subs) => {
        return window.i18n.__('%(staff)s a modifié les collaborateurs de la tâche', subs);
    },
    'marketing.email.clicked': (subs) => {
        return window.i18n.__("A cliqué sur l'email (%(external_id)s) %(external_name)s", subs);
    },
    'marketing.email.opened': (subs) => {
        return window.i18n.__("A ouvert l'email (%(external_id)s) %(external_name)s", subs);
    },
    'marketing.email.received': (subs) => {
        return window.i18n.__(
            "A été destinataire de l'email (%(external_id)s) %(external_name)s",
            subs,
        );
    },
    'marketing.form.opened': (subs) => {
        return window.i18n.__('A ouvert le formulaire (%(external_id)s) %(external_name)s', subs);
    },
    'marketing.form.submitted': (subs) => {
        return window.i18n.__('A soumis le formulaire (%(external_id)s) %(external_name)s', subs);
    },
    'marketing.page.clicked': (subs) => {
        return window.i18n.__(
            'A cliqué dans une landing page (%(external_id)s) %(external_name)s',
            subs,
        );
    },
    'marketing.page.opened': (subs) => {
        return window.i18n.__(
            'A visité une landing page (%(external_id)s) %(external_name)s',
            subs,
        );
    },
    'marketing.sms.answered': (subs) => {
        return window.i18n.__('A répondu au SMS (%(external_id)s) %(external_name)s', subs);
    },
    'marketing.sms.clicked': (subs) => {
        return window.i18n.__('A cliqué sur le SMS (%(external_id)s) %(external_name)s', subs);
    },
    'marketing.sms.sent': (subs) => {
        return window.i18n.__('Le contact a reçu le SMS (%(external_id)s) %(external_name)s', subs);
    },
    'marketing.survey.opened': (subs) => {
        return window.i18n.__('A ouvert une enquête (%(external_id)s) %(external_name)s', subs);
    },
    'marketing.survey.submitted': (subs) => {
        return window.i18n.__("A soumis l'enquête (%(external_id)s) %(external_name)s", subs);
    },
    'marketing.transactional-email.clicked': (subs) => {
        return window.i18n.__("A cliqué sur l'email transactionnel (%(external_id)s)", subs);
    },
    'marketing.transactional-email.opened': (subs) => {
        return window.i18n.__("L'email transactionnel a été ouvert (%(external_id)s)", subs);
    },
    'marketing.transactional-email.received': (subs) => {
        return window.i18n.__("L'email transactionnel a été reçu (%(external_id)s)", subs);
    },
    'marketing.transactional-email.sent': (subs) => {
        return window.i18n.__("L'email transactionnel a été envoyé (%(external_id)s)", subs);
    },
};

export default TIMELINE_WORDINGS;
